<template>
  <div ref="myEcharts" :style="{ height, width }"></div>
</template>
<script setup >
// props="['width','height','right1Data']"
import { ref, onMounted,defineProps } from "vue";
import * as echarts from "echarts";
const props =defineProps({
  width: {
    type: String,
    default: "100%",
  },
  height: {
    type: String,
    default: "100%",
  },
  listData: {
    type: Object,
    default: () => {},
  },
})
// console.log(props.listData);
const myEcharts = ref(null);

onMounted(() => {
  // let data = [
  //   { value: 287.5, name: "2023年全县生产总值" },
  //   { value: 54.57, name: "第一产业增加值" },
  //   { value: 93.51, name: "第二产业增加值" },
  //   { value: 139.44, name: "第三产业增加值" },
  // ];
  initChart(props.listData);
});

function initChart(listData) {
  if (myEcharts.value && myEcharts.value.chart) {
    myEcharts.value.chart.dispose();
  }

  const chartInstance = echarts.init(myEcharts.value);
  // 农事记录、农资记录、农产品记录、地块记录

  const option= {
    tooltip: {
      trigger: "item",
      formatter: "数据统计 <br/>{b} : {c} ({d}%)"
    },
    // 还原内部文字
    // title: {
    //   text: '得分',
    //   top: "45%",
    //   left: "center",
    //   subtext: "占比",
    //   itemGap: 8,
    //   textStyle: {
    //     color: "#18191B",
    //     fontSize: 28,
    //     fontWeight: 400
    //   },
    //   subtextStyle: {
    //     color: "#18191B",
    //     fontSize: 28
    //   },
    // },
    color: ["#1B86E9", "#0C9B8D",  "#F5B01D","#445565",],
    series: [
      // 外部真实圆环
      {
        name: "",
        type: "pie",
        radius: ["38%", "57%"],
        center: ["53%", "center"],
        data: [
          {
            value: 68,
            name: '地块记录',
            label: {
              color: "#1B86E9"
            },
            color: "#fff"
          },
          {
            value: 958,
            name: "农事记录",
            label: {
              color: "#0C9B8D"
            }
          },
          {
            value: 256,
            name: "农资记录",
            label: {
              color: "#F5B01D"
            },
            color: "#1B86E9"
          },
          {
            value: 89,
            name: "农产品记录",
            label: {
              color: "#445565"
            },
            color: "#0C9B8D"
          },

        ],
        label: {
          formatter: function (params) {
            // return `{normal|${params.name}：}{value|${params.data.value} (${params.percent})%}`
            return `{normal|${params.name}}{value|${params.percent}%}`
          },
          rich: {
            normal: {
              color: "#fff",
              fontSize: 16,
              align: "left"
            },
            value: {
              fontSize:16,
            }
          }
        },
        // 间隔
        itemStyle: {
          normal: {
            borderWidth: 0,
            borderColor: '#fff',
          },
        },
      },
      // 内部绿色装饰圆环
      {
        type: 'pie',
        tooltip: {
          show: false
        },
        center: ['53%', '50%'],
        radius: ['32%', '32%'],
        label: {
          show: false // 不展示data中的value和name
        },
        data: [
          {
            value: 1, // 此处的值无所谓是多少
            name: '', // 因为不展示label，可不填
            itemStyle: {
              // 边框样式，浅蓝色，颜色可自行修改
              borderWidth: 8, // 边框宽度
              borderColor: '#48A4A680' // 边框颜色
            }
          }
        ]
      }
    ]
  };// 将你的ECharts配置项放在这里
    chartInstance.setOption(option, true);
}
  window.addEventListener("resize", () => {
    chartInstance.resize();
  });

</script>
<style lang="less"></style>
